<router-outlet />

@if (authStore.loadingAuthSate() == "loading") {
  <div
    class="fixed inset-0 bg-[var(--mat-sys-background)] grid place-items-center z-50"
  >
    <div class="flex flex-col gap-2 items-center max-w-2xs w-full">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>

      <p
        class="mat-body-medium tracking-wider text-[var(--mat-sys-on-surface-variant)] !font-light"
      >
        Fetching user information
      </p>
    </div>
  </div>
}

<ng-template #loadingModal>
  <div class="flex flex-col gap-4 items-center">
    <mat-spinner diameter="32"></mat-spinner>
  </div>
</ng-template>
